export const generateHeadingId = (headingText) => headingText
  .toLowerCase()
  .match(/[a-z0-9_{\s}.-]+/g)
  .map(String.prototype.trim.call.bind(String.prototype.trim))
  .join(' ')
  .split(' ')
  .join('_');

export const removeAllSelect = () => {
  const selectedItems = document.getElementsByClassName('menu-selected');
  for (const item of selectedItems) {
    item.classList.remove('menu-selected');
  }
};

export const goTo = (element) => {
  const parentDiv = document.getElementsByClassName('notion-row');
  if (parentDiv.length === 1) {
    parentDiv[0].scrollIntoView({
      behavior: 'auto',
      block: 'end',
    });
  }
  element.scrollIntoView({
    behavior: 'auto',
    block: 'nearest',
  });
};

/**
 * Utility function to filter an object by role.
 * Removes keys where the "role" property equals the specified value.
 *
 * @param {Object} obj - The object to filter.
 * @param {string} excludedRole - The role value to exclude (e.g., "none").
 * @returns {Object} - A new object with the filtered entries.
 */
export const filterObjectByRole = (obj, excludedRole) => Object.fromEntries(
  Object.entries(obj).filter(([key, value]) => value.role !== excludedRole),
);
